import { mapMultiSelectDropDownField } from '@ninja/utilities';
import { CustomerWebSiteAppInitResponse } from '@shory-health-individual/customer-api';
import { useAppPlatformContextOptions } from '../../../../../../contexts/app';
import { useCountries } from '../../../../../app-init-data';
import { NetworkSearchFilterForm } from '../useNetworkListForm';

export type PlanCity = {
	id: number;
	name: string;
	countryId: number;
};

export const usePlanCountry = () => {
	const { translate } = useAppPlatformContextOptions();
	const { getCountryById } = useCountries();

	const getCountries = (planCities: PlanCity[]) => {
		const countryIds = [...new Set(planCities.map((city) => city.countryId))];

		return countryIds.map((countryId) => getCountryById(countryId)) as CustomerWebSiteAppInitResponse['countries'];
	};

	const getCountryFromPlan = (planCities: PlanCity[]) =>
		mapMultiSelectDropDownField<NetworkSearchFilterForm, { id: number; name: string }, 'id'>({
			field: 'countryIds',
			options: getCountries(planCities),
			label: translate('quote-list:quote-benefits-modal.network-list-content.country'),
			placeholder: translate('quote-list:quote-benefits-modal.network-list-content.placeholder-select'),
			labelKey: 'name',
			valueKey: 'id',
			isSearchable: true,
			cancelButtonText: translate('quote-list:quote-benefits-modal.network-list-content.cancel'),
			applyButtonText: translate('quote-list:quote-benefits-modal.network-list-content.apply'),
		});

	return { getCountryFromPlan };
};
